import React from "react";
import UnderConstructionComponent from '../../components/UnderConstruction/UnderConstruction';

function UnderConstruction(props) {
  return <UnderConstructionComponent/>;
}

export default UnderConstruction;
